import axiosInstance from "./axios";
import { Price } from "./models/prices.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchPrices = async (
  bearerToken: string,
  year: number
): Promise<Price[]> => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/Prices?year=${year}`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch prices:", error);
    throw error;
  }
};
